import { PARENT_MODAL_DOMAIN, modalMessages } from "../constants/responses";

const handleBackToBind = () => {
  const params = new URLSearchParams(window.location.search);
  if (params.get("origin") === "link") {
    window.close();
    setTimeout(() => {
      if (!window.closed) {
        window.location.href = "/done";
      }
    }, 1);
  } else {
    PARENT_MODAL_DOMAIN.forEach((domain) => {
      window.parent.postMessage(
        { message: modalMessages.CLOSED },
        domain
      );
    });
  }
};

export default handleBackToBind;
